import { useCallback } from 'react';

import { maxZoom, minZoom } from 'flow-builder/constants';
import { EditorContext } from 'flow-builder/types/context';

type UseZoomOptions = Pick<EditorContext, 'state' | 'view'>;
type UseZoomReturn = (newScale: number) => void;

export function useZoom({ state, view }: UseZoomOptions): UseZoomReturn {
  const { setViewState } = state;

  const onZoom = useCallback<UseZoomReturn>(
    (newScale) => {
      if (!view.isReady) {
        return;
      }

      const restrictedNewScale = Math.min(Math.max(newScale, minZoom), maxZoom);

      view.viewport.setZoom(restrictedNewScale, true);
      setViewState({ scale: restrictedNewScale });
    },
    [view.isReady, view.viewport, setViewState],
  );

  return onZoom;
}
